import clsx from 'clsx';
import { HTMLAttributes, useEffect, useState } from 'react';
import { OnlineServiceData, useWebChatAPI } from '../../api';
import { useLayoutStore, usePopupStore } from '../../../layout';
import { WebChat } from '../WebChat';
import { FloatingButton } from './FloatingButton';
import { isEmpty } from 'lodash-es';
import styles from './ChatBot.module.scss';
import { useRtnResponse } from '@trg/api';

interface ChatbotProps extends HTMLAttributes<HTMLButtonElement> {
  chat: OnlineServiceData;
}

export function Chatbot({ chat, ...props }: ChatbotProps) {
  const isDesktop = useLayoutStore.use.isDesktop();
  const [serviceUrl, setServiceUrl] = useState<string | null>(null);
  const [chatUrl, setChatUrl] = useState<string | null>(null);
  const isWebChatOpen = usePopupStore.use.isWebChatOpen();
  const setWebChatOpen = usePopupStore.use.setWebChatOpen();
  const { data: webchatResponse, isError } = useWebChatAPI({ url: serviceUrl });

  useRtnResponse({
    payload: webchatResponse,
    onSuccess: (_, { rtnMsg: chatUrl }) => {
      setChatUrl(chatUrl);
      return;
    },
  });

  if (isEmpty(chat)) return null;

  const showChatPanel = () => {
    if (isWebChatOpen) return;
    setServiceUrl(chat.link);
    setWebChatOpen(true);
  };

  const toNewLocation = () => {
    if (chat.linkTarget === 'Y' && chat.link) {
      window.open(chat.link);
    }
    if (chat.linkTarget === 'N' && chat.link) {
      window.location.href = chat.link;
    }
  };

  const btnClickFn = () => {
    const isOpenChat = chat.isOpenChat === 'Y';
    if (isOpenChat) {
      showChatPanel();
    } else {
      toNewLocation();
    }
  };

  return (
    <>
      <FloatingButton
        {...props}
        className=""
        onClick={btnClickFn}
        id="NoChatbot"
      >
        <img
          src={isDesktop ? chat?.imageMediasUrl : chat?.mobileImageMediasUrl}
          alt="Online Service"
        />
      </FloatingButton>
      <WebChat show={isWebChatOpen} onClick={() => setWebChatOpen(false)}>
        {chatUrl && (
          <iframe
            title="customer_service"
            className={clsx(styles['iframe'], 'tlw-bg-white')}
            src={chatUrl}
            frameBorder={0}
          />
        )}
      </WebChat>
    </>
  );
}
